import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormMessageComponent } from './form-message.component';
import { FormMessagesComponent } from './form-messages.component';
import { FormValidateComponent } from './form-validate.component';
import { FormSubmittedComponent } from './form-submitted.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule
    ],
    exports: [
        FormMessageComponent,
        FormMessagesComponent,
        FormValidateComponent,
        FormSubmittedComponent
    ],
    declarations: [
        FormMessageComponent,
        FormMessagesComponent,
        FormValidateComponent,
        FormSubmittedComponent
    ]
})

export class FormValidationModule {
}
